"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawContents = void 0;
const helpers_1 = require("../helpers");
function drawContents(context, { contents, scale }) {
    const adjustedScale = (0, helpers_1.adjustScale)(context);
    context.save();
    context.lineWidth = 2 * adjustedScale / scale;
    context.strokeStyle = 'blue';
    contents.forEach(content => {
        context.strokeRect(content.x, content.y, content.width, content.height);
    });
    context.lineWidth = 1 * adjustedScale / scale;
    context.strokeStyle = 'green';
    contents.forEach(content => {
        if (content.type === 'image') {
            const dimensionFlipped = content.image.rotation % 2 === 1;
            const horizontalScale = dimensionFlipped
                ? content.height / content.image.clippingMask.width
                : content.width / content.image.clippingMask.width;
            const verticalScale = dimensionFlipped
                ? content.width / content.image.clippingMask.height
                : content.height / content.image.clippingMask.height;
            context.save();
            context.translate(content.x, content.y);
            if (content.image.rotation) {
                const centerOffsetWidth = content.width / 2;
                const centerOffsetHeight = content.height / 2;
                context.translate(centerOffsetWidth, centerOffsetHeight);
                context.rotate(-content.image.rotation * Math.PI / 2);
                context.translate(dimensionFlipped ? -centerOffsetHeight : -centerOffsetWidth, dimensionFlipped ? -centerOffsetWidth : -centerOffsetHeight);
            }
            context.strokeRect(-content.image.clippingMask.x * horizontalScale, -content.image.clippingMask.y * verticalScale, content.image.width * horizontalScale, content.image.height * verticalScale);
            context.restore();
        }
    });
    context.restore();
}
exports.drawContents = drawContents;
